import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiHome, FiMap, FiGrid, FiBriefcase, FiUser, FiSearch, FiLogOut, FiMenu } from 'react-icons/fi';
import { AuthContext } from '../context/AuthContext';
import './Header.css';

const MobileHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const { api } = useContext(AuthContext);
  const [unreadLeadsCount, setUnreadLeadsCount] = useState(0);

  useEffect(() => {
    if (user && ['seller', 'agent', 'builder', 'admin'].includes(user.role)) {
      api.get('/enquiries/unread-count')
        .then(res => {
          if (res.data && res.data.unreadCount !== undefined) {
            setUnreadLeadsCount(res.data.unreadCount);
          }
        })
        .catch(err => console.error('Failed to fetch unread count:', err));
    }
  }, [user, api]);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/' ? 'text-primary' : 'text-gray-500';
    if (path === '/properties') {
      const match = location.pathname === '/properties' || location.pathname.startsWith('/property/') || location.pathname.startsWith('/wealth-property/') || location.pathname === '/rent';
      return match ? 'text-primary' : 'text-gray-500';
    }
    if (path === '/projects') {
      const match = location.pathname === '/projects' || location.pathname.startsWith('/project/') || location.pathname.startsWith('/wealth-project/');
      return match ? 'text-primary' : 'text-gray-500';
    }
    if (path === '/map') return location.pathname === '/map' ? 'text-primary' : 'text-gray-500';
    if (path === '/profile') {
      const match = location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/admin') || location.pathname === '/login';
      return match ? 'text-primary' : 'text-gray-500';
    }
    return 'text-gray-500';
  };

  return (
    <>
      {/* Top App Bar */}
      <header className="fixed top-0 left-0 w-full bg-white shadow-sm z-[9999] px-4 py-3 flex justify-between items-center">
        <div className="flex items-center gap-2" onClick={() => navigate('/')}>
          <img src="/icon-192.png" alt="Real Properties" className="w-8 h-8 object-contain" />
          <span className="font-bold text-lg text-primary">Real Properties</span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/map" className="text-gray-600 text-xl">
            <FiSearch />
          </Link>
          {user ? (
            <Link to={user.role === 'admin' ? '/admin' : '/dashboard'} className="relative text-gray-600 text-xl">
              <FiUser />
              {unreadLeadsCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] rounded-full h-4 w-4 flex items-center justify-center">
                  {unreadLeadsCount}
                </span>
              )}
            </Link>
          ) : (
            <Link to="/login" className="text-gray-600 text-xl">
              <FiUser />
            </Link>
          )}
        </div>
      </header>

      {/* Spacer for Top Bar */}
      <div className="h-[60px] w-full"></div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 w-full bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-[9999] flex justify-around items-center py-2 pb-safe">
        <Link to="/" className={`flex flex-col items-center p-2 ${isActive('/')}`}>
          <FiHome className="text-2xl mb-1" />
          <span className="text-[10px] font-medium">Home</span>
        </Link>
        <Link to="/map" className={`flex flex-col items-center p-2 ${isActive('/map')}`}>
          <FiMap className="text-2xl mb-1" />
          <span className="text-[10px] font-medium">Map</span>
        </Link>
        <Link to="/properties" className={`flex flex-col items-center p-2 ${isActive('/properties')}`}>
          <FiGrid className="text-2xl mb-1" />
          <span className="text-[10px] font-medium">Properties</span>
        </Link>
        <Link to="/projects" className={`flex flex-col items-center p-2 ${isActive('/projects')}`}>
          <FiBriefcase className="text-2xl mb-1" />
          <span className="text-[10px] font-medium">Projects</span>
        </Link>
        <Link to={user ? (user.role === 'admin' ? '/admin' : '/dashboard') : '/login'} className={`flex flex-col items-center p-2 ${isActive('/profile')}`}>
          <FiUser className="text-2xl mb-1" />
          <span className="text-[10px] font-medium">Profile</span>
        </Link>
      </nav>
    </>
  );
};

export default MobileHeader;
